import { useToast } from "../../contexts/toast-context";

export const useGlobalNotificationLogic = () => {
    const { notification, hideNotification } = useToast();

    const shouldRender = Boolean(notification.isVisible && notification.type);

    const handleClick = () => {
        // Auto-hide on click for error and success, but not for loading
        if (notification.type !== "loading") {
            hideNotification();
        }
    };

    return {
        notification,
        hideNotification,
        shouldRender,
        handleClick,
    };
};
